import useGoogleAdsManager from '@nuxt-common/site-monetization/app/composables/useGoogleAdsManager.js';
import { useEnvProps } from '~/composables/useEnvProps';
import { usePageData } from '~/composables/usePageData';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';

export default function useSiteMonGAMTags() {
  const { referrer, product, topLevelCategoryID, brandName } = usePageData();
  const brandBlocked = product?.product?.detail?.brand?.brandBlocked || false;
  const { killswitches } = useKillswitches();
  const { isMobile } = useDeviceType();
  const { brand, tagMngrEnv } = useEnvProps();
  const tagParams = {
    device: isMobile.value ? 'mobile' : 'desktop',
    page: 'pdp',
    enableGAMAdsFromApp: killswitches?.enableGAMAdsFromApp || false,
    enableGAMImpressionTags: killswitches?.enableGAMImpressionTags || false,
    enableGAMClickTags: killswitches?.enableGAMClickTags || false,
    refererURL: referrer || '',
    tagEnv: tagMngrEnv,
    brand,
    productBrand: brandName,
    catID: product?.analytics?.data?.t_category_id[0] || '',
    topLevelCatID: topLevelCategoryID || '',
    isBrandBlocked: brandBlocked,
  };
  useGoogleAdsManager.initGAMTags(tagParams);
}
